<template>
    <DCard
        :title="__('orders.show.sales')"
        :main-title-has-slot="true"
        padding
    >
        <template #titleHasSlot>
            <DSwitch
                color="success"
                variant="3d"
                :disabled="isInLoadingState"
                :checked="showSection"
                @update:checked="showCardSection"
            />
        </template>
        <DRow v-if="showSection">
            <DCol col="6">
                <DFormRow :label="__('orders.show.sales_representative')">
                    {{ order.salesRepresentative }} {{ salesPerson }}
                </DFormRow>
            </DCol>
            <DCol col="6" />
            <DCol
                v-if="order.client === 'PSA'"
                col="6"
            >
                <DFormRow :label="__('orders.show.agency')">
                    <p>
                        <Link
                            v-if="order.agency !== null"
                            :href="$route('customers.customers.show', {customer: order.agency.id})"
                        >
                            {{ order.agency.id }}
                        </Link>
                        <DButton
                            v-if="order.agency !== null"
                            color="secondary"
                            icon="delete"
                            mini
                            @click="deleteAgency"
                        />
                        <DButton
                            color="secondary"
                            icon="pencil"
                            mini
                            @click="openAgencyModal"
                        />
                    </p>
                    <p v-if="order.agency !== null && order.agency.company !== null">
                        {{ order.agency.company }}
                    </p>
                    <p v-if="order.agency !== null && (order.agency.firstname !== null || order.agency.lastname !== null)">
                        {{ order.agency.firstname }} {{ order.agency.lastname }}
                    </p>
                </DFormRow>
            </DCol>
            <DCol col="6" />
            <DCol
                v-if="order.client === 'PSA'"
                col="6"
            >
                <DFormRow :label="__('orders.show.commission_recipient')">
                    {{ order.commissionRecipient }}
                </DFormRow>
            </DCol>
        </DRow>
        <AgencyModal
            v-if="showAgencyModal === true"
            :show-modal="showAgencyModal === true"
            :segments="segments"
            :selected-segments="selectedSegmentsData"
            @close="closeAgencyModal"
            @confirm="updateAgency"
        />
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { computed, ref, watch } from 'vue'
import { __ } from '~@/Composables/translation'
import AgencyModal from '~@/Components/Orders/Psa/AgencyModal'

const props = defineProps({
    order: {
        type: Object,
        default () {
            return {}
        }
    },
    section: {
        type: String,
        default () {
            return ''
        }
    },
    showSection: {
        type: Boolean,
        default () {
            return true
        }
    },
    userListView: {
        type: Array,
        default: () => {
            return []
        }
    },
    segments: {
        type: Array,
        default () {
            return []
        }
    },
    selectedSegments: {
        type: Array,
        default () {
            return []
        }
    }
})

const emit = defineEmits(['update-list'])

const columns = ref(props.userListView)
const selectedSegmentsData = ref(props.selectedSegments)

const form = useForm({
    columns: props.userListView
})

watch(() => props.selectedSegments, (newData, oldData) => {
    selectedSegmentsData.value = newData
})

function showCardSection (value) {
    for (const column of columns.value) {
        if (column.column === props.section) {
            column.show_column = value
        }
    }

    form.columns = flattenColumns(columns.value)

    form.post(route('settings.list-view-settings.store'))

    emit('update-list', columns.value)
}

function flattenColumns (columns) {
    if (columns.length === 0) {
        return {}
    }

    const result = {}

    for (const [key, column] of Object.entries(columns)) {
        result[key] = JSON.parse(JSON.stringify(column))
    }

    return result
}

const salesPerson = computed(() => {
    return props.order.salesPerson !== null
        ? `${props.order.salesPerson?.external_id ?? '0'}, ${props.order.salesPerson?.firstname ?? ''} ${props.order.salesPerson?.lastname ?? ''}`
        : __('orders.show.unknown_agent')
})

const showAgencyModal = ref(false)

function openAgencyModal () {
    showAgencyModal.value = true
}

function closeAgencyModal (values) {
    const segments = []
    for (const item of values) {
        segments.push(String(item))
    }

    selectedSegmentsData.value = segments
    showAgencyModal.value = false
}

function updateAgency (formAgency) {
    formAgency.order_id = props.order.idInternal

    formAgency.post(route('orders.psa.save-agency-customer'), {
        onSuccess: () => {
            showAgencyModal.value = false
        },
        onError: () => {
            showAgencyModal.value = false
        }
    })
}

function deleteAgency () {
    const formAgency = useForm({
        order_id: props.order.idInternal
    })

    formAgency.post(route('orders.psa.delete-agency-customer'), {
        onSuccess: () => {
        },
        onError: () => {
        }
    })
}

</script>

<style scoped>

</style>
